import { deepClone } from '@/services/ObjectFormatter'
export default {
    methods: {
        mixDeepClone: deepClone,
        stopAndPrevent: function(e) {
            e.preventDefault()
            e.stopPropagation()
        },
    },
}
